import { useSeo } from "@/lib/seo";

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Camera, Smartphone, Laptop, Gamepad2, Music, Shirt, Home as HomeIcon, Sofa, Bike, Cpu, Book, Tablet, Watch, ArrowRight, WalletCards } from "lucide-react";
import { api } from "@/lib/api";

const ICONS = {
  "Trading Cards": WalletCards,
  Cameras: Camera,
  Phones: Smartphone,
  Computers: Laptop,
  Tablets: Tablet,
  Gaming: Gamepad2,
  Music: Music,
  Clothing: Shirt,
  Home: HomeIcon,
  Furniture: Sofa,
  Sports: Bike,
  Electronics: Cpu,
  Books: Book,
  "Jewelry & Watches": Watch,
};

const COLORS = ["#FEF3C7|#92400E", "#E0EDFA|#0445A0", "#DCFCE7|#166534", "#FCE7F3|#9D174D", "#EDE9FE|#5B21B6", "#FFEDD5|#9A3412", "#E0F2FE|#075985", "#FEF9C3|#854D0E", "#F1F5F9|#334155"];

export default function Categories() {
  useSeo({
    title: "Trade Categories — Cameras, Phones, Gaming & More | Vyrti",
    description: "Browse every Vyrti category: cameras, phones, computers, gaming, music, clothing, furniture, jewelry & watches and more — all trade-only.",
    path: "/categories",
  });
  const [cats, setCats] = useState([]);

  useEffect(() => {
    api.get("/listings/categories").then(({ data }) => setCats(data.items || [])).catch(() => setCats([]));
  }, []);

  return (
    <div className="section-pad py-8 md:py-12" data-testid="categories-page">
      <h1 className="font-display font-bold text-3xl md:text-4xl tracking-tight">Categories</h1>
      <p className="text-zinc-500 mt-2">Discover trades across every kind of item</p>

      <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {cats.map((c, i) => {
          const Icon = ICONS[c.category] || Camera;
          const [bg, fg] = (COLORS[i % COLORS.length]).split("|");
          return (
            <Link
              key={c.category}
              to={`/browse?category=${encodeURIComponent(c.category)}`}
              className="vyrti-card p-6 group block"
              data-testid={`cat-tile-${c.category.toLowerCase()}`}
            >
              <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: bg, color: fg }}>
                <Icon className="w-6 h-6" />
              </div>
              <h3 className="font-display font-semibold text-lg mt-4">{c.category}</h3>
              <p className="text-sm text-zinc-500 mt-1">{c.count} active</p>
              <div className="mt-4 text-[#0654BA] text-sm flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                Explore <ArrowRight className="w-4 h-4" />
              </div>
            </Link>
          );
        })}
      </div>

      {cats.length === 0 && (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 mt-10">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="vyrti-card p-6 space-y-3">
              <div className="skeleton w-12 h-12" />
              <div className="skeleton h-4 w-2/3" />
              <div className="skeleton h-3 w-1/3" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
